import { ReturnItem } from 'types/types';
import { createAction } from 'typesafe-actions';

export const setReturnItems = createAction('@order/SET_RETURNS')<
  ReturnItem[]
>();

export const clearReturns = createAction('@order/CLEAR_RETURNS')();
